import React from 'react';
import { render } from 'react-dom';

import FlashMessages from './FlashMessages';

const init = (): void => {
  const root = document.getElementById('__flowgate-flash-messages-root');
  if (!root) return;
  render(<FlashMessages />, root);
};

export default { init };
